export default __webpack_public_path__ + "static/media/6.36953a97.jpg";